import React from "react";
import cns from "classnames";
import { transparentize } from "polished";
import MuiTableRow, { TableRowProps } from "@material-ui/core/TableRow";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

export type Props = TableRowProps & {
  disabled?: boolean;
};

export function TableRow(props) {
  const classes = useStyles({});
  const { className: classNameProp, disabled, ...rest } = props;

  const className = cns(classNameProp, {
    [classes.disabled]: disabled
  });

  return <MuiTableRow className={className} {...rest} />;
}

const useStyles = makeStyles((theme: ThemeType) => ({
  disabled: {
    backgroundColor: theme.palette.disabled.main,

    "& *": {
      color: transparentize(0.2, theme.palette.text.main)
    }
  }
}));
